import { useId } from 'react'
import ReactMultiSelect from '~/components/react_multi_select/react_multi_select'
import useRetryablePostJSON from '~/hooks/use_retryable_post_json'

export default function MultiSelect({ name, label, url, params, selected, onChange, id, classNamePrefix, ...props }) {
  const defaultElementId = useId()
  const elementId = id || defaultElementId
  let options, isLoading

  if (url) {
    const initialData = []
    // biome-ignore lint/correctness/useHookAtTopLevel: todo: fix this
    const response = useRetryablePostJSON({ path: url, params, initialData })
    options = response.data
    isLoading = response.isLoading
  } else {
    options = props.options
    isLoading = false
  }

  return (
    <>
      <label htmlFor={elementId} className='form-label'>
        {label}
      </label>

      <ReactMultiSelect
        classNamePrefix={classNamePrefix}
        id={elementId}
        name={name}
        selected={selected}
        options={options}
        onChange={onChange}
        isLoading={isLoading}
      />
    </>
  )
}
